define("shared/components/shared/version-picker", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _tracking, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div style="position: fixed; top: 0; right: 0; z-index: 100;">
    {{#if this.isEnabled}}
      <Shared::Ui::Button
        @type={{unless this.isNewVersionPicked "primary" "outline"}}
        @text={{"v1"}}
        @onClick={{fn this.setNewVersion false}}
      />
      <Shared::Ui::Button
        @type={{if this.isNewVersionPicked "primary" "outline"}}
        @text={{"v2"}}
        @onClick={{fn this.setNewVersion true}}
      />
    {{/if}}
  </div>
  
  {{#if (has-block)}}
    {{yield this.isNewVersionPicked}}
  {{/if}}
  
  */
  {
    "id": "sGMTvdaM",
    "block": "[[[10,0],[14,5,\"position: fixed; top: 0; right: 0; z-index: 100;\"],[12],[1,\"\\n\"],[41,[30,0,[\"isEnabled\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@type\",\"@text\",\"@onClick\"],[[52,[51,[30,0,[\"isNewVersionPicked\"]]],\"primary\",\"outline\"],\"v1\",[28,[37,3],[[30,0,[\"setNewVersion\"]],false],null]]],null],[1,\"\\n    \"],[8,[39,1],null,[[\"@type\",\"@text\",\"@onClick\"],[[52,[30,0,[\"isNewVersionPicked\"]],\"primary\",\"outline\"],\"v2\",[28,[37,3],[[30,0,[\"setNewVersion\"]],true],null]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[48,[30,1]],[[[1,\"  \"],[18,1,[[30,0,[\"isNewVersionPicked\"]]]],[1,\"\\n\"]],[]],null]],[\"&default\"],false,[\"if\",\"shared/ui/button\",\"unless\",\"fn\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/version-picker.hbs",
    "isStrictMode": false
  });

  /**
   * @class VersionPicker
   * /
   * @extends Component
   *
   * This component renders a toggle element (a version picker), which
   * can either be "v1" or "v2".
   *
   * If this component is invoked as a block, it will yield a boolean
   * `isNewVersionPicked` with the state of the version picker.
   *
   * If an action is passed in, the component can be used inline and the value
   * of `isNewVersionPicked` will be passed to the action on every value update.
   *
   * Required Arguments:
   * - isEnabled (Boolean) Whether the user can pick a new version (based on business logic)
   *
   * Optional Arguments:
   * - setNewVersion (Method) An action called on every update to `isNewVersionPicked`
   *
   * Examples:
   *
   * Inline usage with action:
   * ```
   * <Shared::VersionPicker
   *   @isEnabled={{this.canAccessFeatureName}}
   *   @setNewVersion={{this.setNewVersion}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::VersionPicker
   *   @isEnabled={{this.canAccessFeatureName}}
   * as |isNewVersionPicked|>
   *  {{#if isNewVersionPicked}}
   *    <div>New Version</div>
   *  {{/if}}
   * </Shared::VersionPicker>
   * ```
   *
   */
  let VersionPickerComponent = (_class = class VersionPickerComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isNewVersionPicked", _descriptor, this);
    }

    get isEnabled() {
      return this.args.isEnabled;
    }

    setNewVersion(isNewVersionPicked) {
      this.isNewVersionPicked = isNewVersionPicked;

      if (this.args.setNewVersion && typeof this.args.setNewVersion === 'function') {
        this.args.setNewVersion(isNewVersionPicked);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isNewVersionPicked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setNewVersion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setNewVersion"), _class.prototype)), _class);
  _exports.default = VersionPickerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, VersionPickerComponent);
});